import constants from '../services/constants';
import { atom } from 'recoil';

const amITeamAdminAtom = atom<boolean>({
    key: constants.amITeamAdminAtom,
    default: undefined,
});

export default amITeamAdminAtom;
